import { isRoomInvalid } from "@/utils/roomVerificationState";

export type RoomAccessDecision = "allow" | "fallback-dc" | "verify";

type RouteLike = {
  name: string | symbol | null | undefined;
  query: Record<string, unknown>;
};

type UserLike = {
  homepageConfig?: { secureRoomVerificationEnabled?: boolean };
  genericQRCode?: boolean;
  attributes?: Record<string, unknown>;
};

const informationRoutes = new Set([
  "page_dc",
  "page_hotel_info",
  "page_things_to_do",
  "page_thingstodo_detail",
  "page_facilities",
  "page_facilities_detail",
  "page_promotion",
]);

const roomRoutes = new Set([
  "page_home",
  "page_assistance",
  "page_basic",
  "page_activity",
  "page_buggy",
]);

export function resolveRoomAccess(
  route: RouteLike,
  user: UserLike,
  apiKey: string,
  merchantId: string,
): RoomAccessDecision {
  const name = typeof route.name === "string" ? route.name : "";
  if (informationRoutes.has(name) || !roomRoutes.has(name)) return "allow";
  if (user.homepageConfig?.secureRoomVerificationEnabled === false)
    return "allow";
  if (
    name === "page_assistance" &&
    route.query.roomEntry === "generic" &&
    typeof route.query.assistanceOption === "string"
  )
    return "allow";
  // Buggy is roomless on the server. This context controls its entry UX only.
  if (name === "page_buggy" && route.query.source === "dc") return "allow";

  const invalid = isRoomInvalid(apiKey, merchantId);
  if (!invalid) {
    if (user.genericQRCode) return "allow";
    const room = user.attributes?.user_room_number;
    if (typeof room === "string" && room.trim() && room !== "null")
      return "allow";
    if (typeof room === "number" && Number.isFinite(room)) return "allow";
  }

  if (
    (name === "page_assistance" &&
      typeof route.query.assistanceOption === "string" &&
      route.query.assistanceOption) ||
    (name === "page_buggy" &&
      (route.query.to === "buggy" ||
        route.query.pickupId ||
        route.query.destinationId))
  )
    return "verify";
  return "fallback-dc";
}
